import type { ObjectDirective } from 'vue'

interface ClickOutsideElement extends HTMLElement {
  clickOutsideEvent?: (event: Event) => void
  touchStartEvent?: (event: Event) => void
}

const ClickOutsideDirective: ObjectDirective<ClickOutsideElement, (event: Event) => void> = {
  beforeMount: (el, binding) => {
    let touchStarted = false

    el.clickOutsideEvent = (event) => {
      if (!(el === event.target || el.contains(event.target as Node))) {
        binding.value(event)
      }
    }

    el.touchStartEvent = (event) => {
      touchStarted = true
      el.clickOutsideEvent?.(event)
    }

    el.clickOutsideEvent = (event) => {
      if (!touchStarted) {
        if (!(el === event.target || el.contains(event.target as Node))) {
          binding.value(event)
        }
      }
      touchStarted = false
    }

    document.body.addEventListener('click', el.clickOutsideEvent)
    document.body.addEventListener('touchstart', el.touchStartEvent)
  },
  beforeUnmount: (el) => {
    document.body.removeEventListener('click', el.clickOutsideEvent!)
    document.body.removeEventListener('touchstart', el.touchStartEvent!)
  },
}

export default ClickOutsideDirective
